(function () {
  const PARAM = 'grail_filter';

  function getConfig() {
    const node = document.querySelector('[data-grail-quick-filters-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function getActiveFilter() {
    return getSearchParams().get(PARAM) || '';
  }

  function normalize(value) {
    return (value || '').toString().toLowerCase();
  }

  function productMatchesFilter(item, filter) {
    if (!filter) return true;

    const title = normalize(item.dataset.grailTitle);
    const tags = normalize(item.dataset.grailTags);
    const badge = normalize(item.dataset.grailBadge);
    const price = Number(item.dataset.grailPrice || 0);
    const haystack = `${title} ${tags}`;
    const checks = [];

    if (filter.keywords && filter.keywords.length) {
      const keywordHit = filter.keywords.some((keyword) => {
        const needle = normalize(keyword);
        return needle && haystack.includes(needle);
      });
      checks.push(keywordHit);
    }

    if (filter.badge && filter.badge !== 'none') {
      checks.push(badge === normalize(filter.badge));
    }

    if (filter.priceMax > 0) {
      checks.push(price <= filter.priceMax * 100);
    }

    if (!checks.length) return true;
    return checks.some(Boolean);
  }

  function getFilterByKey(config, key) {
    if (!config || !key) return null;
    return (config.filters || []).find((filter) => filter.key === key) || null;
  }

  function getProductItems(grid) {
    return Array.from(
      grid.querySelectorAll(
        ':scope > li.grid__item:not(.grail-preorder-banner-item):not(.grail-collection-quick-filters__empty)'
      )
    );
  }

  function rememberOriginalOrder(items) {
    items.forEach((item, index) => {
      if (item.dataset.grailOriginalIndex == null) {
        item.dataset.grailOriginalIndex = String(index);
      }
    });
  }

  function moveTrailingChrome(grid) {
    const banner = grid.querySelector(':scope > li.grail-preorder-banner-item');
    const emptyState = grid.querySelector(':scope > li.grail-collection-quick-filters__empty');
    if (banner) grid.appendChild(banner);
    if (emptyState) grid.appendChild(emptyState);
  }

  function restoreOriginalOrder(grid, items) {
    items
      .slice()
      .sort(
        (a, b) =>
          Number(a.dataset.grailOriginalIndex || 0) - Number(b.dataset.grailOriginalIndex || 0)
      )
      .forEach((item) => grid.appendChild(item));
    moveTrailingChrome(grid);
  }

  function applyNewArrivals(grid, items, limit) {
    items
      .slice()
      .sort(
        (a, b) => Number(b.dataset.grailCreated || 0) - Number(a.dataset.grailCreated || 0)
      )
      .forEach((item, index) => {
        item.hidden = index >= limit;
        grid.appendChild(item);
      });
    moveTrailingChrome(grid);
  }

  function getGridColumnCount(grid) {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const raw = isMobile
      ? grid.dataset.grailColsMobile || '2'
      : grid.dataset.grailColsDesktop || '4';
    const cols = Number.parseInt(raw, 10);
    return Number.isFinite(cols) && cols > 0 ? cols : isMobile ? 2 : 4;
  }

  /**
   * Full-width banner breaks the flex row. If it sits after a non-multiple of
   * column count (common after chip filters hide products), the last row shows
   * a blank cell. Reposition after N visible products, snapped to a full row.
   */
  function repositionPreorderBanner(grid) {
    const banner = grid.querySelector(':scope > li.grail-preorder-banner-item');
    if (!banner) return;

    const afterSetting = Number.parseInt(grid.dataset.grailPreorderAfter || '', 10);
    if (!Number.isFinite(afterSetting) || afterSetting < 1) return;

    const products = Array.from(
      grid.querySelectorAll(
        ':scope > li.grid__item:not(.grail-preorder-banner-item):not(.grail-collection-quick-filters__empty)'
      )
    );
    const visible = products.filter((item) => !item.hidden);
    const cols = getGridColumnCount(grid);

    let insertAfter = Math.min(afterSetting, visible.length);
    insertAfter = Math.floor(insertAfter / cols) * cols;

    if (insertAfter < cols) {
      banner.hidden = true;
      return;
    }

    banner.hidden = false;
    const anchor = visible[insertAfter - 1];
    if (!anchor) {
      banner.hidden = true;
      return;
    }

    if (anchor.nextElementSibling !== banner) {
      anchor.after(banner);
    }
  }

  function applyFilterToGrid(filterKey, updateUrl) {
    const config = getConfig();
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const items = getProductItems(grid);
    rememberOriginalOrder(items);

    const filter = filterKey && filterKey !== 'new' ? getFilterByKey(config, filterKey) : null;
    let visibleCount = 0;

    if (filterKey === 'new') {
      const limit = Math.max(1, Number(config && config.newLimit) || 75);
      applyNewArrivals(grid, items, limit);
      visibleCount = Math.min(items.length, limit);
    } else {
      restoreOriginalOrder(grid, items);
      items.forEach((item) => {
        const show = productMatchesFilter(item, filter);
        item.hidden = !show;
        if (show) visibleCount += 1;
      });
    }

    repositionPreorderBanner(grid);

    const emptyState = grid.querySelector('.grail-collection-quick-filters__empty');
    if (emptyState) emptyState.hidden = visibleCount !== 0;

    if (updateUrl) {
      const params = getSearchParams();
      if (!filterKey) params.delete(PARAM);
      else params.set(PARAM, filterKey);
      const search = params.toString();
      const nextUrl = search ? `${window.location.pathname}?${search}` : window.location.pathname;
      window.history.replaceState({ searchParams: search }, '', nextUrl);
    }
  }

  function syncChipStates() {
    const active = getActiveFilter();
    document.querySelectorAll('[data-grail-filter-chip]').forEach((chip) => {
      const key = chip.dataset.grailFilterChip || '';
      const isActive = key === '' ? active === '' || active === 'all' : active === key;
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function setActiveChip(chip) {
    document.querySelectorAll('[data-grail-filter-chip]').forEach((el) => {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    chip.classList.add('is-active');
    chip.setAttribute('aria-pressed', 'true');
  }

  function onChipClick(event) {
    const chip = event.currentTarget;
    if (chip.tagName !== 'BUTTON') return;
    event.preventDefault();
    setActiveChip(chip);
    const filterKey = chip.dataset.grailFilterChip || '';
    applyFilterToGrid(filterKey, true);
    syncChipStates();
  }

  function patchFacetFilters() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm._grailQuickFilterPatched) return;

    const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer.bind(FacetFiltersForm);
    FacetFiltersForm.renderProductGridContainer = function (html) {
      originalRenderProductGridContainer(html);
      const active = getActiveFilter();
      if (active) applyFilterToGrid(active, false);
      syncChipStates();
    };

    FacetFiltersForm._grailQuickFilterPatched = true;
  }

  function init(container) {
    patchFacetFilters();
    container.querySelectorAll('[data-grail-filter-chip]').forEach((chip) => {
      chip.addEventListener('click', onChipClick);
    });

    const active = getActiveFilter();
    if (active) applyFilterToGrid(active, false);
    syncChipStates();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.grail-collection-quick-filters').forEach(init);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.grail-collection-quick-filters');
    if (container) init(container);
  });

  window.addEventListener('popstate', () => {
    const active = getActiveFilter();
    applyFilterToGrid(active, false);
    syncChipStates();
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      const grid = document.getElementById('product-grid');
      if (grid) repositionPreorderBanner(grid);
    }, 150);
  });
})();
